<template>
  <div class="locations-and-regions">
    <AdminNavigation ref="navigation" indexProps="9"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Regions</h1></div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="2-4"/>
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <el-select @change="selectPage(1)" style="max-width: 200px" placeholder="Select State"  class="mr-1" v-model="listParam.StateID" filterable  clearable>
                <el-option v-for="item in stateList" :key="item.StateID" :value="item.StateID"
                           :label="decodeURI(item.StateName)"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="content-scroll-x">
          <div>
            <div>
              <table class="table">
                <thead>
                <tr>
                  <th style="width:20%" class="long-text">Region Name</th>
                  <th style="width:45%" class="long-text">Region Description</th>
                  <th style="width:20%" class="long-text">State</th>
                  <th style="width:15%;vertical-align:middle" class="icon-col">
                    <div class="icon-group justify-content-center align-items-center" v-if="user.type >= 6">
                      <v-btn class="add-icon" @click="dialogVisible = true" dark>Add New</v-btn>
                    </div>
                  </th>
                </tr>
                </thead>
              </table>
            </div>
            <!-- <div :class="locations.length > 5 ? 'content-scroll-y' : ''"> -->
            <div>
              <table class="table">
                <tbody>
                <tr v-for="region in regions" :key="region.RegionID">
                  <td style="width:20%" class="long-text">{{ decodeURI(region.RegionName) }}</td>
                  <td style="width:45%" class="long-text">{{ region.RegionDescription }}</td>
                  <td style="width:20%" class="long-text">{{ decodeURI(region.State) }}</td>
                  <td style="width:15%; vertical-align:middle" class="icon-col">
                    <div class="icon-group justify-content-center align-items-center">
                      <img @click="currentObj=$_.cloneDeep(region); dialogVisible=true" data-toggle="tooltip" data-placement="right"
                           title="Edit Region" src="@/assets/images/edit_icon.svg"/>
                      <img v-if="user.type >= 6" data-toggle="tooltip" data-placement="right"
                           title="Delete Region" @click="showDelete(region)" src="@/assets/images/delete_icon.svg"/>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
    <el-dialog
        class="edit-zoho-dialog"
        :title="currentObj.RegionID ? 'Edit Region' : 'Add Region'"
        :visible.sync="dialogVisible"
        @close="closeModal"
        width="50%">
      <div>
        <el-form ref="ruleForm" :model="currentObj" label-width="180px" :rules="rules">
          <el-form-item label="Region Name" prop="RegionName">
            <el-input placeholder="Region Name" v-model="currentObj.RegionName" maxlength="32"></el-input>
          </el-form-item>
          <el-form-item label="State" prop="StateID">
            <el-select class="w-100" v-model="currentObj.StateID" filterable clearable placeholder="Select Country"
                       :loading="loadingSelect">
              <el-option v-for="item in stateList" :key="item.StateID" :value="item.StateID"
                         :label="decodeURI(item.StateName)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Region Description" prop="RegionDescription">
            <el-input type="textarea" v-model="currentObj.RegionDescription" maxlength="100" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <v-btn class="white-button me-2" dark @click="dialogVisible = false">Cancel</v-btn>
    <v-btn dark :disabled="user.type < 6" :loading="loading" @click="submitForm('ruleForm')">Save</v-btn>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSettingsMenu from '@/components/AdminSettingsMenu'
import Header from '@/components/Header'

export default {
  name: 'AdminLocationsAndRegions',
  components: {
    AdminNavigation,
    AdminSettingsMenu,
    Header,
  },
  data() {
    const regionNameValidator = (rule, value, callback) => {
      const s = String(value || '').trim()
      if (!s) {
        callback(new Error('Region Name is required.'))
        return
      }
      if (s.length > 32) {
        callback(new Error('Region Name must not exceed 32 characters.'))
        return
      }
      if (!/(?=.*[A-Za-z])/.test(s)) {
        callback(new Error('Region Name must include at least one English letter.'))
        return
      }
      if (!/^[A-Za-z\s-]+$/.test(s)) {
        callback(new Error('Region Name may only contain English letters, spaces, and hyphens (-).'))
        return
      }
      callback()
    }
    const regionDescriptionValidator = (rule, value, callback) => {
      const s = String(value || '').trim()
      if (!s) {
        callback()
        return
      }
      if (s.length > 100) {
        callback(new Error('Region Description must not exceed 100 characters.'))
        return
      }
      if (!/(?=.*[A-Za-z])/.test(s)) {
        callback(new Error('Region Description must include at least one English letter.'))
        return
      }
      if (!/^[A-Za-z\s\-()&]+$/.test(s)) {
        callback(new Error('Region Description may only contain English letters, spaces, hyphens (-), parentheses ( ), and ampersand (&).'))
        return
      }
      callback()
    }
    return {
      currentObj: {
        RegionName: '',
        StateID: null,
        RegionDescription: '',
      },
      loadingSelect: false,
      stateList: [],
      rules: {
        RegionName: [
          {validator: regionNameValidator, trigger: ['blur', 'change']},
        ],
        StateID: [
          {required: true, message: 'Please select state', trigger: 'change'},
        ],
        RegionDescription: [
          {validator: regionDescriptionValidator, trigger: ['blur', 'change']},
        ],
      },
      loading: false,
      regions: [],
      dialogVisible: false,
      totalCount: 0,
      listParam: {
        pageNum: 1,
        pageSize: 10,
        StateID: null,
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    closeModal() {
      this.$refs.ruleForm.resetFields()
      this.currentObj = {
        RegionName: '',
        RegionCode: '',
        StateID: null,
        RegionDescription: ''
      }
    },
    showDelete(c) {
      this.$confirm({
        content: `Are you sure you wish to delete the region: ${c.RegionName}?`,
        onConfirm: () => {
          utilities.deleteRegionNew(c.RegionID).then(() => {
            this.$notify({
              dangerouslyUseHTMLString: true,
              message: '<div class="alert-success">' +
                  '            <b>Success:</b> Region Deleted !' +
                  '          </div>',
            });
            this.selectPage(1)
          })
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.currentObj.RegionName = String(this.currentObj.RegionName || '').trim()
          this.currentObj.RegionDescription = String(this.currentObj.RegionDescription || '').trim()
          this.loading = true
          if (this.currentObj.RegionID) {
            const id = this.currentObj.RegionID
            const obj = {...this.currentObj}
            delete obj.RegionID
            delete obj.StateCode
            delete obj.State
            utilities.putRegionNew(id, obj).then(() => {
              this.loading = false
              this.dialogVisible = false
              this.$notify({
                dangerouslyUseHTMLString: true,
                message: '<div class="alert-success">' +
                    '            <b>Success:</b> Region Updated !' +
                    '          </div>',
              });
              this.selectPage(1)
            }).catch(() => {
              this.loading = false
            })
          } else {
            utilities.postRegionNew(this.currentObj).then(() => {
              this.loading = false
              this.dialogVisible = false
              this.$notify({
                dangerouslyUseHTMLString: true,
                message: '<div class="alert-success">' +
                    '            <b>Success:</b> Region Created !' +
                    '          </div>',
              });
              this.selectPage(1)
            }).catch(() => {
              this.loading = false
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.getData()
    },
    async getData() {
      await this.$store.dispatch('loading/setLoadComponent', true)
      const {data, count} = await utilities.getRegionsNew(this.listParam)
      this.regions = data
      this.totalCount = count
      await this.$store.dispatch('loading/setLoadComponent', false)
    },
  },
  async beforeMount() {
    await this.getData()
    const {data} = await utilities.getStatesNew({pageNum: 1, pageSize: 999})
    this.stateList = data
  },
  mounted() {
  },
}
</script>
